'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactInstantsearchCore = require('react-instantsearch-core');

var _PanelCallbackHandler = require('../components/PanelCallbackHandler');

var _PanelCallbackHandler2 = _interopRequireDefault(_PanelCallbackHandler);

var _CurrentRefinements = require('../components/CurrentRefinements');

var _CurrentRefinements2 = _interopRequireDefault(_CurrentRefinements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The CurrentRefinements widget displays the list of currently applied filters.
 *
 * It allows the user to selectively remove them.
 * @name CurrentRefinements
 * @kind widget
 * @propType {function} [transformItems] - Function to modify the items being displayed, e.g. for filtering or sorting them. Takes an items as parameter and expects it back in return.
 * @themeKey ais-CurrentRefinements - the root div of the widget
 * @themeKey ais-CurrentRefinements--noRefinement - the root div of the widget when there is no refinement
 * @themeKey ais-CurrentRefinements-list - the list of all refined items
 * @themeKey ais-CurrentRefinements-list--noRefinement - the list of all refined items when there is no refinement
 * @themeKey ais-CurrentRefinements-item - the refined list item
 * @themeKey ais-CurrentRefinements-button - the button of each refined list item
 * @themeKey ais-CurrentRefinements-label - the refined list label
 * @themeKey ais-CurrentRefinements-category - the category of each item
 * @themeKey ais-CurrentRefinements-categoryLabel - the label of each catgory
 * @themeKey ais-CurrentRefinements-delete - the delete button of each label
 * @translationKey clearFilter - the remove filter button label
 * @example
 * import React from 'react';
 * import { InstantSearch, CurrentRefinements, RefinementList } from 'react-instantsearch-dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <CurrentRefinements />
 *     <RefinementList
 *       attribute="colors"
 *       defaultRefinement={['Black']}
 *     />
 *   </InstantSearch>
 * );
 */

var CurrentRefinementsWidget = function CurrentRefinementsWidget(props) {
  return _react2.default.createElement(
    _PanelCallbackHandler2.default,
    props,
    _react2.default.createElement(_CurrentRefinements2.default, props)
  );
};

exports.default = (0, _reactInstantsearchCore.connectCurrentRefinements)(CurrentRefinementsWidget);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/widgets/CurrentRefinements.js
// module id = 1005
// module chunks = 142807904292071